import { ENTITLEMENT_GROUP_VALUE } from '../src/utils/localStorageKeys';
import { getEntitlementGroup, getLocallyStoredUser } from '../src/utils/userStorage';

interface Environment {
    ISSUER: string;
    EXPIRATION_TIME: string;
    AUD: string;
    AUTHORIZATION_GROUP: Array<string>;
    CLIENT_ID: string;
    EMAIL: string;
    ENTITLEMENT_GROUP: Array<string>;
    FAMILIY_NAME: string;
    GIVEN_NAME: string;
    SUB: string;
}

export interface LoggedInUser {
    id: string;
    email: string;
    familyName: string;
    givenName: string;
    username: string;
}

export const baseUser: LoggedInUser = {
    id: process.env.BASE_USER_ID,
    email: process.env.BASE_USER_EMAIL,
    familyName: process.env.BASE_USER_FAMILY_NAME,
    givenName: process.env.BASE_USER_GIVEN_NAME,
    username: process.env.BASE_USER_USERNAME,
} as LoggedInUser;

export const getLoggedInUser = (): LoggedInUser => {
    const user = getLocallyStoredUser();

    if (user) {
        return user as LoggedInUser;
    } else {
        return baseUser;
    }
};
const loggedInUser = getLoggedInUser();

const environment: Environment = {
    ISSUER: 'http://localhost:8080',
    EXPIRATION_TIME: '2h',
    AUD: loggedInUser.id,
    AUTHORIZATION_GROUP: [],
    CLIENT_ID: loggedInUser.id,
    EMAIL: loggedInUser.email,
    ENTITLEMENT_GROUP: getEntitlementGroup(ENTITLEMENT_GROUP_VALUE),
    FAMILIY_NAME: loggedInUser.familyName,
    GIVEN_NAME: loggedInUser.givenName,
    SUB: loggedInUser.username,
};

export default environment;
